import { motion } from 'motion/react';

export default function AnimatedAccount() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <motion.path
        initial={{ pathLength: 0, pathOffset: 1 }}
        animate={{ pathLength: 1, pathOffset: 0 }}
        transition={{ duration: 1.5 }}
        d="M3.00011 13.9649L2.99544 14.2753L3.16729 14.5337C4.63471 16.7405 7.15113 18.2 10 18.2C12.8489 18.2 15.3653 16.7405 16.8327 14.5337L17.0046 14.2753L16.9999 13.9649C16.987 13.1073 16.5439 12.4257 16.0128 11.9289C15.4857 11.4359 14.8053 11.0572 14.1205 10.7711C13.0251 10.3134 11.7638 10.0294 10.7233 9.93502C12.5892 9.59545 14 7.96525 14 6C14 3.78772 12.2123 2 10 2C7.78772 2 6 3.78772 6 6C6 7.96497 7.41035 9.59499 9.27588 9.93488C8.23272 10.0291 6.97072 10.3131 5.87539 10.7712C5.191 11.0574 4.51143 11.4363 3.9851 11.9296C3.45456 12.4267 3.01303 13.1082 3.00011 13.9649ZM1 10C1 5.03228 5.03228 1 10 1C14.9677 1 19 5.03228 19 10C19 14.9677 14.9677 19 10 19C5.03228 19 1 14.9677 1 10Z"
        strokeWidth={2}
      />
    </svg>
  );
}
